import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-monitor';

export default {
    path: '/bcos/monitor',
    name: '系统监控',
    redirect: {
        name: `${pre}nodesMetric`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'nodesMetric',
            name: `${pre}nodesMetric`,
            meta: {
                ...meta,
                title: '节点监控',
                closable: true
            },
            component: () => import('@/bcos/views/monitor/nodes-metric.vue')
        },
        {
            path: 'hostMetric',
            name: `${pre}hostMetric`,
            meta: {
                ...meta,
                title: '主机监控',
                closable: true
            },
            component: () => import('@/bcos/views/monitor/host-metric.vue')
        },
        {
            path: 'emailAlarm',
            name: `${pre}emailAlarm`,
            meta: {
                ...meta,
                title: '邮件告警配置',
                closable: true
            },
            component: () => import('@/bcos/views/monitor/email-alarm.vue')
        },
        {
            path: 'emailAlarmType',
            name: `${pre}emailAlarmType`,
            meta: {
                ...meta,
                title: '告警类型配置',
                closable: true
            },
            component: () => import('@/bcos/views/monitor/email-alarm-type.vue')
        },
    ]
};
